import React from "react";
import "./Loader.css";
import loading from "./loading.svg";

export const Loader = () => {
  return (
    <div className="main-container">
    <div className="loader-size">
      <img src={loading} alt="" style={{ height: "100px" }} />
    </div>
    </div>
  );
};
